export function formatTimeRange(startTime, endTime, onlyMonthDay = false, showTimeZone = false) {
  const startDate = new Date(startTime);
  const endDate = new Date(endTime);

  let timeZone = '';

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');

    timeZone = date.toString().match(/\(([^)]+)\)$/)[1];

    return onlyMonthDay ? `${yyyy}/${mm}/${dd}` : `${yyyy}/${mm}/${dd} ${hh}:${min}`;
  };

  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);

  return showTimeZone ? `${formattedStart} ~ ${formattedEnd} (${timeZone})` : `${formattedStart} ~ ${formattedEnd}`;
}
